import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../../mensajes2";
import { validaSoloNumero } from "../../../../util/varios";
import axios from "axios";
import { Dimmer } from "../../../spinner";
import CatalogoSolvencia from "./catalogoSolvencia";

const ModalSolvencia = (props) => {
  const op = require("../../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [body, setBody] = useState({
    codigoSolve: "",
    codigoContri: "",
    fecha: "",
    cedula: "",
    nombre: "",
    direccion: "",
    organismo: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const buscarSolvencia = async () => {
    setLoading(true);
    const campos = `idsolvencia, idcontribuyente, nombre, cedularif, direccion, fechaemision, dirigido`;
    const tabla = `solvencia`;
    const condi = `idsolvencia = ${body.codigoSolve}`;
    const orden = "1=1";
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.length > 0) {
          const data = res.data[0];
          setBody((prev) => ({
            ...prev,
            codigoContri: data.idcontribuyente,
            fecha: new Date(data.fechaemision).toISOString().split("T")[0],
            cedula: data.cedularif,
            nombre: data.nombre,
            direccion: data.direccion,
            organismo: data.dirigido,
          }));
          setDisabled(false);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "",
            texto: "No Existen registros",
            icono: "informacion",
          });
          setDisabled(true);
        }
      })
      .catch((res) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Buscar la Solvencia",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.key === "Enter" || event.which === 13) {
      validarCampos();
    }
  };
  const validarCampos = () => {
    if (!body.codigoSolve) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
    } else {
      buscarSolvencia();
    }
  };
  const imprimirSolvencia = () => {
    try {
      if (body.codigoSolve === "") {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Generar el Reporte de Solvencias",
          icono: "error",
        });
        return;
      }
      const condicion = `idsolvencia = ${body.codigoSolve}`;
      window.open(
        op.reportes +
          "/actividadeconomica?" +
          "reporte=solvenciapaez" +
          "&CONDICION=" +
          condicion,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte de Solvencias",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    setBody({
      codigoSolve: "",
      codigoContri: "",
      fecha: "",
      cedula: "",
      nombre: "",
      direccion: "",
      organismo: "",
    });
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setLoading(false);
    setDisabled(true);
  };
  const cerrar = () => {
    props.hidden();
  };
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      size="xl"
      contentClassName="p-0 m-0"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold text-light m-0">Consultar Solvencias</h3>
        <button className="btn btn-sm bg-light" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-md-12 row mx-auto">
          <div className="col-md-3 mr-1 row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Código Solvencia:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="codigoSolve"
                onKeyUp={handleInputNumChange}
                onBlur={handleInputNumChange}
                onChange={handleChange}
                value={body.codigoSolve}
              />
              <button
                onClick={() => setMostrarCatalogo(true)}
                style={{ textAlign: "center", color: "white" }}
                className="btn btn-sm btn-info"
              >
                <i className="fas fa-search" />
              </button>
            </div>
          </div>
          <div className="col-md-3 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Código Contribuyente:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="codigoContri"
                value={body.codigoContri}
                disabled
              />
            </div>
          </div>
          <div className="col-md-3 ml-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Fecha de Emisión:
              </span>
              <input
                type="date"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="fecha"
                value={body.fecha}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 row mx-auto">
          <div className="col-md-4 mr-1 row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Cédula/Rif del Contribuyente:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="cedula"
                disabled
                value={body.cedula}
              />
            </div>
          </div>
          <div className="col-md-6 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nombre Contribuyente:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="nombre"
                disabled
                value={body.nombre}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 row mx-auto">
          <div className="col-md-8 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Dirección del Contribuyente:
              </span>
              <textarea
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="direccion"
                disabled
                value={body.direccion}
                style={{
                  minHeight: "40px",
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 row mx-auto">
          <div className="col-md-8 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Organismo a quien se dirige:
              </span>
              <textarea
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="organismo"
                disabled
                value={body.organismo}
                style={{
                  minHeight: "40px",
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          disabled={disabled}
          onClick={() => imprimirSolvencia()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-primary btn-sm rounded-pill"
        >
          <i className="fa fa-print"> Imprimir</i>
        </button>
        <button
          onClick={() => blanquear()}
          type="button"
          style={{ margin: "2px" }}
          className="fw-bold btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
      <CatalogoSolvencia
        show={mostrarCatalogo}
        hidden={() => setMostrarCatalogo(false)}
        seleccionarRegistro={(e) => {
          setBody(e)
          setDisabled(false)
        }}
      />
    </Modal>
  );
};

export default ModalSolvencia;
